import type { IMultiSelectItem } from "@/interfaces";
import type { NewFilterTypes } from "@/types";

const toMultiSelectItem = (item: NewFilterTypes): IMultiSelectItem => {
  return {
    id: item.id,
    title: item.title,
  };
};

export default {
  toMultiSelectItem,
};
